import { render, staticRenderFns } from "./ClassRollCallPrivAdmin.vue?vue&type=template&id=1a583186&scoped=true"
import script from "./ClassRollCallPrivAdmin.vue?vue&type=script&lang=js"
export * from "./ClassRollCallPrivAdmin.vue?vue&type=script&lang=js"
import style0 from "./ClassRollCallPrivAdmin.vue?vue&type=style&index=0&id=1a583186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a583186",
  null
  
)

export default component.exports